import React from 'react';
import './ContactHero.css';

function ContactHero() {
  return (
    <section 
      className="contact-hero" 
      id="contact-hero"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/contact-hero-bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1a1a1a'
      }}
    >
      <div className="contact-hero-overlay"></div>
      <div className="container">
        <div className="contacthero-content">
          <div className="contacthero-text">
            <h1 className="contacthero-title">Contacto</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactHero;
